const STORAGE_KEY = 'vanti.recentEntities';
const MAX = 5;

export function loadRecentEntities() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function pushRecentEntity(entry) {
  if (!entry?.kind || !entry?.id) return;
  const list = loadRecentEntities().filter((e) => !(e.kind === entry.kind && e.id === entry.id));
  list.unshift({
    kind: entry.kind,
    id: entry.id,
    label: entry.label || '',
  });
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX)));
}

export function recordRecentFromRoute(pathname, params, scopeMeta) {
  if (scopeMeta?.projectId) {
    pushRecentEntity({
      kind: 'project',
      id: scopeMeta.projectId,
      label: scopeMeta.projectName || 'Project',
    });
  } else if (scopeMeta?.repositoryId) {
    pushRecentEntity({
      kind: 'repository',
      id: scopeMeta.repositoryId,
      label: scopeMeta.repositoryFullName || 'Repo',
    });
  } else if (scopeMeta?.streamId) {
    pushRecentEntity({
      kind: 'stream',
      id: scopeMeta.streamId,
      label: scopeMeta.streamName || 'Stream',
    });
  } else if (scopeMeta?.memberUserId) {
    pushRecentEntity({
      kind: 'member',
      id: scopeMeta.memberUserId,
      label: scopeMeta.memberDisplayName || 'Member',
    });
  } else if (params?.projectId) {
    pushRecentEntity({ kind: 'project', id: params.projectId, label: 'Project' });
  } else if (params?.streamId) {
    pushRecentEntity({ kind: 'stream', id: params.streamId, label: 'Stream' });
  }
}
